export default __webpack_public_path__ + "static/media/levelTest-Illustration08.816e8dbe.jpg";